import styled from 'styled-components';
import { ADVENTURE_GREEN, ADVENTURE_GREEN_AUTOFILLED, BACKGROUND_GRAY, ELEMENT_GRAY, RIOJA_RED, SENSATION_WHITE } from '../../colors';
const FormWrapper = styled.div`
  position: relative;
  display: flex;
  box-sizing: border-box;
  border: 1px solid ${ELEMENT_GRAY};
  border-radius: 4px;
  background-color: ${SENSATION_WHITE};
  transition: border-color 0.2s ease-out, background-color 0.2s ease-out;
  :focus-within {
    outline: none;
    border-color: ${ADVENTURE_GREEN};
  }
  ${({
  $autofilled
}) => $autofilled ? `
        background-color: ${ADVENTURE_GREEN_AUTOFILLED};
      ` : ''}
  ${({
  $focused
}) => $focused ? `
        border-color: ${ADVENTURE_GREEN};
      ` : ''}
  ${({
  $error,
  $disabled,
  $withPersistError
}) => $error ? `
        border-color: ${RIOJA_RED}${$withPersistError && !$disabled ? ' !important' : ''};
      ` : ''}
  ${({
  $disabled
}) => $disabled ? `
        border-color: ${ELEMENT_GRAY};
        background-color: ${BACKGROUND_GRAY};
      ` : ''}
  ${({
  $withPrefix
}) => $withPrefix ? `
        border-left: 0;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      ` : ''}
  ${({
  $withSuffix
}) => $withSuffix ? `
        border-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      ` : ''}
  ${({
  $noBorder
}) => $noBorder ? `
        border: none !important;
      ` : ''}
`;
export default FormWrapper;